import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Enum3alwj03lh1n41 as Enum,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Bid1s5165cmyi3p0 as Bid,
  ShiftDrop11wleufu73phm as ShiftDrop,
  ShiftTrade2id415mgfo6y4 as ShiftTrade,
  IShiftDropAccessor3c2fgb3dksv1c as IShiftDropAccessor,
  IShiftDropMutatoryf0dvdej6sad as IShiftDropMutator,
  IShiftTradeAccessorqhpl7uylbpey as IShiftTradeAccessor,
  IShiftTradeMutatorrs3huyo9trn7 as IShiftTradeMutator,
} from './Shared7Punches-domain-shiftpool-domain.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
import { IShiftInvalidator3ba6keaeoutnl as IShiftInvalidator } from './Shared7Punches-domain-shift-domain.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ShiftPool, 'ShiftPool', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(ShiftBid, 'ShiftBid', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(ShiftPoolBid, 'ShiftPoolBid', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiShiftDrop, 'ApiShiftDrop', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiShiftTrade, 'ApiShiftTrade', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForClass(ApiShiftTradeStatus, 'ApiShiftTradeStatus', VOID, Enum);
initMetadataForLambda(ShiftDropRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(ShiftDropRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForClass(ShiftDropRepository, 'ShiftDropRepository', VOID, VOID, [IShiftDropAccessor, IShiftDropMutator], [1, 2]);
initMetadataForLambda(ShiftTradeRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(ShiftTradeRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForClass(ShiftTradeRepository, 'ShiftTradeRepository', VOID, VOID, [IShiftTradeAccessor, IShiftTradeMutator], [1, 2]);
initMetadataForInterface(IShiftDropRemoteSource, 'IShiftDropRemoteSource', VOID, VOID, VOID, [0, 2, 1]);
initMetadataForInterface(IShiftTradeRemoteSource, 'IShiftTradeRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForCoroutine($getShiftPoolRequestsCOROUTINE$16, CoroutineImpl);
initMetadataForClass(ShiftDropRemoteSource, 'ShiftDropRemoteSource', VOID, VOID, [IShiftDropRemoteSource], [0, 1, 2]);
initMetadataForCoroutine($getShiftTradesCOROUTINE$23, CoroutineImpl);
initMetadataForClass(ShiftTradeRemoteSource, 'ShiftTradeRemoteSource', VOID, VOID, [IShiftTradeRemoteSource], [1, 2]);
//endregion
function toDomain(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.c8m_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = new Bid(item.e8m_1.d8m_1);
    destination.e(tmp$ret$0);
  }
  return new ShiftDrop(_this__u8e3s4.b8m_1.f8m_1, destination);
}
function toDomain_0(_this__u8e3s4) {
  return new ShiftTrade(_this__u8e3s4.g8m_1);
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.shiftpool.data.model.ApiShiftDrop.ShiftPool', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.h8m_1 = tmp0_serialDesc;
}
protoOf($serializer).i8m = function (encoder, value) {
  var tmp0_desc = this.h8m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.us(tmp0_desc, 0, value.f8m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.i8m(encoder, value instanceof ShiftPool ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.h8m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.pr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.pr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ShiftPool_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.h8m_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ShiftPool_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().h8m_1);
  }
  $this.f8m_1 = id;
  return $this;
}
function ShiftPool_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ShiftPool_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ShiftPool)));
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.shiftpool.data.model.ApiShiftDrop.ShiftBid', this, 1);
  tmp0_serialDesc.wy('shift_pool_bid', false);
  this.j8m_1 = tmp0_serialDesc;
}
protoOf($serializer_0).k8m = function (encoder, value) {
  var tmp0_desc = this.j8m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_1(), value.e8m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.k8m(encoder, value instanceof ShiftBid ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.j8m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ShiftBid_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.j8m_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_1()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ShiftBid_init_$Init$(seen0, shiftPoolBid, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().j8m_1);
  }
  $this.e8m_1 = shiftPoolBid;
  return $this;
}
function ShiftBid_init_$Create$(seen0, shiftPoolBid, serializationConstructorMarker) {
  return ShiftBid_init_$Init$(seen0, shiftPoolBid, serializationConstructorMarker, objectCreate(protoOf(ShiftBid)));
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.shiftpool.data.model.ApiShiftDrop.ShiftPoolBid', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.l8m_1 = tmp0_serialDesc;
}
protoOf($serializer_1).m8m = function (encoder, value) {
  var tmp0_desc = this.l8m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.us(tmp0_desc, 0, value.d8m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.m8m(encoder, value instanceof ShiftPoolBid ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.l8m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.pr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.pr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ShiftPoolBid_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).xn = function () {
  return this.l8m_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance()];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ShiftPoolBid_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().l8m_1);
  }
  $this.d8m_1 = id;
  return $this;
}
function ShiftPoolBid_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ShiftPoolBid_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ShiftPoolBid)));
}
function ApiShiftDrop$Companion$$childSerializers$_anonymous__2z778t() {
  return new ArrayListSerializer($serializer_getInstance_0());
}
function ShiftPool() {
}
protoOf(ShiftPool).toString = function () {
  return 'ShiftPool(id=' + this.f8m_1 + ')';
};
protoOf(ShiftPool).hashCode = function () {
  return this.f8m_1;
};
protoOf(ShiftPool).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftPool))
    return false;
  var tmp0_other_with_cast = other instanceof ShiftPool ? other : THROW_CCE();
  if (!(this.f8m_1 === tmp0_other_with_cast.f8m_1))
    return false;
  return true;
};
function ShiftBid() {
}
protoOf(ShiftBid).toString = function () {
  return 'ShiftBid(shiftPoolBid=' + this.e8m_1.toString() + ')';
};
protoOf(ShiftBid).hashCode = function () {
  return this.e8m_1.hashCode();
};
protoOf(ShiftBid).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftBid))
    return false;
  var tmp0_other_with_cast = other instanceof ShiftBid ? other : THROW_CCE();
  if (!this.e8m_1.equals(tmp0_other_with_cast.e8m_1))
    return false;
  return true;
};
function ShiftPoolBid() {
}
protoOf(ShiftPoolBid).toString = function () {
  return 'ShiftPoolBid(id=' + this.d8m_1 + ')';
};
protoOf(ShiftPoolBid).hashCode = function () {
  return this.d8m_1;
};
protoOf(ShiftPoolBid).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftPoolBid))
    return false;
  var tmp0_other_with_cast = other instanceof ShiftPoolBid ? other : THROW_CCE();
  if (!(this.d8m_1 === tmp0_other_with_cast.d8m_1))
    return false;
  return true;
};
function Companion() {
  Companion_instance_1 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.n8m_1 = [null, lazy(tmp_0, ApiShiftDrop$Companion$$childSerializers$_anonymous__2z778t)];
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.shiftpool.data.model.ApiShiftDrop', this, 2);
  tmp0_serialDesc.wy('shift_pool', false);
  tmp0_serialDesc.wy('shift_bids', false);
  this.o8m_1 = tmp0_serialDesc;
}
protoOf($serializer_2).p8m = function (encoder, value) {
  var tmp0_desc = this.o8m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_2().n8m_1;
  tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance(), value.b8m_1);
  tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1].t(), value.c8m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_2).yn = function (encoder, value) {
  return this.p8m(encoder, value instanceof ApiShiftDrop ? value : THROW_CCE());
};
protoOf($serializer_2).zn = function (decoder) {
  var tmp0_desc = this.o8m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  var tmp7_cached = Companion_getInstance_2().n8m_1;
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiShiftDrop_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_2).xn = function () {
  return this.o8m_1;
};
protoOf($serializer_2).pz = function () {
  var tmp0_cached = Companion_getInstance_2().n8m_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance(), tmp0_cached[1].t()];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function ApiShiftDrop_init_$Init$(seen0, shiftPool, shiftBids, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_2().o8m_1);
  }
  $this.b8m_1 = shiftPool;
  $this.c8m_1 = shiftBids;
  return $this;
}
function ApiShiftDrop_init_$Create$(seen0, shiftPool, shiftBids, serializationConstructorMarker) {
  return ApiShiftDrop_init_$Init$(seen0, shiftPool, shiftBids, serializationConstructorMarker, objectCreate(protoOf(ApiShiftDrop)));
}
function ApiShiftDrop(shiftPool, shiftBids) {
  Companion_getInstance_2();
  this.b8m_1 = shiftPool;
  this.c8m_1 = shiftBids;
}
protoOf(ApiShiftDrop).toString = function () {
  return 'ApiShiftDrop(shiftPool=' + this.b8m_1.toString() + ', shiftBids=' + toString(this.c8m_1) + ')';
};
protoOf(ApiShiftDrop).hashCode = function () {
  var result = this.b8m_1.hashCode();
  result = imul(result, 31) + hashCode(this.c8m_1) | 0;
  return result;
};
protoOf(ApiShiftDrop).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiShiftDrop))
    return false;
  var tmp0_other_with_cast = other instanceof ApiShiftDrop ? other : THROW_CCE();
  if (!this.b8m_1.equals(tmp0_other_with_cast.b8m_1))
    return false;
  if (!equals(this.c8m_1, tmp0_other_with_cast.c8m_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.shiftpool.data.model.ApiShiftTrade', this, 1);
  tmp0_serialDesc.wy('uuid', false);
  this.q8m_1 = tmp0_serialDesc;
}
protoOf($serializer_3).r8m = function (encoder, value) {
  var tmp0_desc = this.q8m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.g8m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_3).yn = function (encoder, value) {
  return this.r8m(encoder, value instanceof ApiShiftTrade ? value : THROW_CCE());
};
protoOf($serializer_3).zn = function (decoder) {
  var tmp0_desc = this.q8m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiShiftTrade_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_3).xn = function () {
  return this.q8m_1;
};
protoOf($serializer_3).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ApiShiftTrade_init_$Init$(seen0, uuid, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_3().q8m_1);
  }
  $this.g8m_1 = uuid;
  return $this;
}
function ApiShiftTrade_init_$Create$(seen0, uuid, serializationConstructorMarker) {
  return ApiShiftTrade_init_$Init$(seen0, uuid, serializationConstructorMarker, objectCreate(protoOf(ApiShiftTrade)));
}
function ApiShiftTrade(uuid) {
  this.g8m_1 = uuid;
}
protoOf(ApiShiftTrade).toString = function () {
  return 'ApiShiftTrade(uuid=' + this.g8m_1 + ')';
};
protoOf(ApiShiftTrade).hashCode = function () {
  return getStringHashCode(this.g8m_1);
};
protoOf(ApiShiftTrade).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiShiftTrade))
    return false;
  var tmp0_other_with_cast = other instanceof ApiShiftTrade ? other : THROW_CCE();
  if (!(this.g8m_1 === tmp0_other_with_cast.g8m_1))
    return false;
  return true;
};
var ApiShiftTradeStatus_PENDING_instance;
var ApiShiftTradeStatus_AWAITING_APPROVAL_instance;
var ApiShiftTradeStatus_COMPLETED_instance;
var ApiShiftTradeStatus_DECLINED_instance;
var ApiShiftTradeStatus_entriesInitialized;
function ApiShiftTradeStatus_initEntries() {
  if (ApiShiftTradeStatus_entriesInitialized)
    return Unit_instance;
  ApiShiftTradeStatus_entriesInitialized = true;
  ApiShiftTradeStatus_PENDING_instance = new ApiShiftTradeStatus('PENDING', 0, 'pending');
  ApiShiftTradeStatus_AWAITING_APPROVAL_instance = new ApiShiftTradeStatus('AWAITING_APPROVAL', 1, 'awaiting_approval');
  ApiShiftTradeStatus_COMPLETED_instance = new ApiShiftTradeStatus('COMPLETED', 2, 'completed');
  ApiShiftTradeStatus_DECLINED_instance = new ApiShiftTradeStatus('DECLINED', 3, 'declined');
}
function ApiShiftTradeStatus(name, ordinal, text) {
  Enum.call(this, name, ordinal);
  this.u8m_1 = text;
}
function ApiShiftTradeStatus_AWAITING_APPROVAL_getInstance() {
  ApiShiftTradeStatus_initEntries();
  return ApiShiftTradeStatus_AWAITING_APPROVAL_instance;
}
function ShiftDropRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.d8n_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ShiftDropRepository$cacheStrategy$slambda).f8n = function (it, $completion) {
  var tmp = this.g8n(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ShiftDropRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.f8n((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(ShiftDropRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.d8n_1.i8n_1.m2u(this.e8n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ShiftDropRepository$cacheStrategy$slambda).g8n = function (it, completion) {
  var i = new ShiftDropRepository$cacheStrategy$slambda(this.d8n_1, completion);
  i.e8n_1 = it;
  return i;
};
function ShiftDropRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new ShiftDropRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.f8n(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function ShiftDropRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.t8n_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ShiftDropRepository$cacheStrategy$slambda_1).u8n = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ShiftDropRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.u8n($completion);
};
protoOf(ShiftDropRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.t8n_1.h8n_1.v8n(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ShiftDropRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new ShiftDropRepository$cacheStrategy$slambda_1(this.t8n_1, completion);
};
function ShiftDropRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new ShiftDropRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.u8n($completion);
  };
  l.$arity = 0;
  return l;
}
function ShiftDropRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function ShiftDropRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.e8c_1;
}
function ShiftDropRepository(remoteSource, localSource, shiftInvalidator) {
  this.h8n_1 = remoteSource;
  this.i8n_1 = localSource;
  this.j8n_1 = shiftInvalidator;
  var tmp = this;
  var tmp_0 = this.i8n_1.n18();
  var tmp_1 = ShiftDropRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = ShiftDropRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = ShiftDropRepository$cacheStrategy$lambda;
  tmp.k8n_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, ShiftDropRepository$cacheStrategy$lambda_0);
}
function ShiftTradeRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.e8o_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ShiftTradeRepository$cacheStrategy$slambda).g8o = function (it, $completion) {
  var tmp = this.h8o(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.g8o((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.e8o_1.j8o_1.m2u(this.f8o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda).h8o = function (it, completion) {
  var i = new ShiftTradeRepository$cacheStrategy$slambda(this.e8o_1, completion);
  i.f8o_1 = it;
  return i;
};
function ShiftTradeRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new ShiftTradeRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.g8o(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function ShiftTradeRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.v8o_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ShiftTradeRepository$cacheStrategy$slambda_1).w8o = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.w8o($completion);
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.v8o_1.i8o_1.x8o(ApiShiftTradeStatus_AWAITING_APPROVAL_getInstance(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ShiftTradeRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new ShiftTradeRepository$cacheStrategy$slambda_1(this.v8o_1, completion);
};
function ShiftTradeRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new ShiftTradeRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.w8o($completion);
  };
  l.$arity = 0;
  return l;
}
function ShiftTradeRepository$cacheStrategy$lambda(it) {
  return toDomain_0(it);
}
function ShiftTradeRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.g8c_1;
}
function ShiftTradeRepository(remoteSource, localSource, sessionDataProvider, shiftInvalidator) {
  this.i8o_1 = remoteSource;
  this.j8o_1 = localSource;
  this.k8o_1 = sessionDataProvider;
  this.l8o_1 = shiftInvalidator;
  var tmp = this;
  var tmp_0 = this.j8o_1.n18();
  var tmp_1 = ShiftTradeRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = ShiftTradeRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = ShiftTradeRepository$cacheStrategy$lambda;
  tmp.m8o_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, ShiftTradeRepository$cacheStrategy$lambda_0);
}
function IShiftDropRemoteSource() {
}
function IShiftTradeRemoteSource() {
}
function ShiftDropRemoteSource$getShiftPoolRequests$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function ShiftDropRemoteSource$getShiftPoolRequests$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getShiftPoolRequestsCOROUTINE$16(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g8p_1 = _this__u8e3s4;
}
protoOf($getShiftPoolRequestsCOROUTINE$16).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.h8p_1 = this.g8p_1.b8r_1;
          this.n8_1 = 1;
          suspendResult = this.g8p_1.c8r_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.i8p_1 = suspendResult;
          this.j8p_1 = this.i8p_1.toString();
          this.k8p_1 = 'company/' + this.j8p_1 + '/shift_pool_requests';
          var tmp_1 = this;
          tmp_1.l8p_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.m8p_1 = this.h8p_1;
          this.n8p_1 = this.k8p_1;
          this.o8p_1 = this.l8p_1;
          var tmp_2 = this;
          tmp_2.p8p_1 = ShiftDropRemoteSource$getShiftPoolRequests$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.r8p_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.s8p_1 = this.m8p_1.f6l_1;
          var tmp_5 = this;
          tmp_5.t8p_1 = buildV2Path(this.m8p_1, this.n8p_1);
          this.u8p_1 = this.s8p_1;
          this.v8p_1 = this.t8p_1;
          var tmp_6 = this;
          tmp_6.w8p_1 = this.u8p_1;
          this.x8p_1 = this.w8p_1;
          var tmp_7 = this;
          tmp_7.y8p_1 = this.x8p_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.v8p_1);
          headers(this_0, ShiftDropRemoteSource$getShiftPoolRequests$lambda_0(this.o8p_1));
          this_0.z5n(this.p8p_1);
          tmp_8.z8p_1 = this_0;
          this.a8q_1 = this.y8p_1;
          this.b8q_1 = this.z8p_1;
          this.b8q_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.c8q_1 = this.a8q_1;
          var tmp_10 = this;
          tmp_10.d8q_1 = this.b8q_1;
          this.e8q_1 = this.c8q_1;
          this.f8q_1 = this.d8q_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.f8q_1, this.e8q_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.g8q_1 = suspendResult;
          var tmp_11 = this;
          this.r8p_1;
          var value = this.g8q_1;
          tmp_11.q8p_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.h8q_1 = this.q8_1;
            var tmp_13 = this;
            throw this.h8q_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.i8q_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.i8q_1;
              tmp_15.q8p_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.j8q_1 = this.q8p_1;
          this.k8q_1 = this.j8q_1;
          this.l8q_1 = Result__exceptionOrNull_impl_p6xea9(this.k8q_1);
          if (this.l8q_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.k8q_1);
            tmp_16.n8q_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.o8q_1 = this.n8q_1;
            var tmp_18 = this;
            tmp_18.p8q_1 = this.o8q_1;
            this.q8q_1 = this.p8q_1;
            this.r8q_1 = this.q8q_1.c4u().z43_1;
            var containsArg = this.r8q_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.u8q_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.w8q_1 = this.q8q_1;
                this.x8q_1 = this.w8q_1;
                this.n8_1 = 7;
                var tmp_21 = this.x8q_1.y4u();
                var tmp_22 = getKClass(KtList);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiShiftDrop), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.y8q_1 = this.q8q_1;
                this.z8q_1 = this.y8q_1;
                this.n8_1 = 6;
                var tmp_26 = this.z8q_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.a8r_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.q8q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.l8q_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.m8q_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.a8r_1;
          tmp_32.s8q_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiShiftDrop), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.v8q_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.v8q_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.v8q_1;
          var tmp_37 = this;
          this.u8q_1;
          tmp_37.t8q_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.t8q_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.t8q_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.s8q_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.m8q_1 = new Result(this.s8q_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.m8q_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function ShiftDropRemoteSource(apiClient, sessionDataProvider) {
  this.b8r_1 = apiClient;
  this.c8r_1 = sessionDataProvider;
}
protoOf(ShiftDropRemoteSource).v8n = function ($completion) {
  var tmp = new $getShiftPoolRequestsCOROUTINE$16(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ShiftTradeRemoteSource$getShiftTrades$lambda($companyId, $status) {
  return function ($this$get, it) {
    $this$get.o44_1.r3q('company_id', $companyId.toString());
    var tmp0_safe_receiver = $status;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$get.o44_1.r3q('status[]', tmp0_safe_receiver.u8m_1);
    }
    return Unit_instance;
  };
}
function ShiftTradeRemoteSource$getShiftTrades$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getShiftTradesCOROUTINE$23(_this__u8e3s4, status, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l8r_1 = _this__u8e3s4;
  this.m8r_1 = status;
}
protoOf($getShiftTradesCOROUTINE$23).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.n8_1 = 1;
          suspendResult = this.l8r_1.i8t_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n8r_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.o8r_1 = this.l8r_1.h8t_1;
          var tmp_1 = this;
          tmp_1.p8r_1 = 'shift_pool_requests';
          var tmp_2 = this;
          tmp_2.q8r_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_3 = this;
          tmp_3.r8r_1 = ShiftTradeRemoteSource$getShiftTrades$lambda(this.n8r_1, this.m8r_1);
          this.s8r_1 = this.o8r_1;
          this.t8r_1 = this.p8r_1;
          this.u8r_1 = this.q8r_1;
          this.v8r_1 = this.r8r_1;
          this.o8_1 = 3;
          var tmp_4 = this;
          tmp_4.x8r_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.y8r_1 = this.s8r_1.f6l_1;
          var tmp_6 = this;
          tmp_6.z8r_1 = buildV2Path(this.s8r_1, this.t8r_1);
          this.a8s_1 = this.y8r_1;
          this.b8s_1 = this.z8r_1;
          var tmp_7 = this;
          tmp_7.c8s_1 = this.a8s_1;
          this.d8s_1 = this.c8s_1;
          var tmp_8 = this;
          tmp_8.e8s_1 = this.d8s_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.b8s_1);
          headers(this_0, ShiftTradeRemoteSource$getShiftTrades$lambda_0(this.u8r_1));
          this_0.z5n(this.v8r_1);
          tmp_9.f8s_1 = this_0;
          this.g8s_1 = this.e8s_1;
          this.h8s_1 = this.f8s_1;
          this.h8s_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.i8s_1 = this.g8s_1;
          var tmp_11 = this;
          tmp_11.j8s_1 = this.h8s_1;
          this.k8s_1 = this.i8s_1;
          this.l8s_1 = this.j8s_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.l8s_1, this.k8s_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.m8s_1 = suspendResult;
          var tmp_12 = this;
          this.x8r_1;
          var value = this.m8s_1;
          tmp_12.w8r_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.n8s_1 = this.q8_1;
            var tmp_14 = this;
            throw this.n8s_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.o8s_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.o8s_1;
              tmp_16.w8r_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.p8s_1 = this.w8r_1;
          this.q8s_1 = this.p8s_1;
          this.r8s_1 = Result__exceptionOrNull_impl_p6xea9(this.q8s_1);
          if (this.r8s_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.q8s_1);
            tmp_17.t8s_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.u8s_1 = this.t8s_1;
            var tmp_19 = this;
            tmp_19.v8s_1 = this.u8s_1;
            this.w8s_1 = this.v8s_1;
            this.x8s_1 = this.w8s_1.c4u().z43_1;
            var containsArg = this.x8s_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_20 = this;
              tmp_20.a8t_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.c8t_1 = this.w8s_1;
                this.d8t_1 = this.c8t_1;
                this.n8_1 = 7;
                var tmp_22 = this.d8t_1.y4u();
                var tmp_23 = getKClass(KtList);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiShiftTrade), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.e8t_1 = this.w8s_1;
                this.f8t_1 = this.e8t_1;
                this.n8_1 = 6;
                var tmp_27 = this.f8t_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.g8t_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.w8s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.r8s_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.s8s_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.g8t_1;
          tmp_33.y8s_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiShiftTrade), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.b8t_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_37 = this;
          tmp_37.b8t_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.b8t_1;
          var tmp_38 = this;
          this.a8t_1;
          tmp_38.z8s_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.z8s_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_43 = this;
          var this_2 = this.z8s_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.y8s_1 = tmp_44.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.s8s_1 = new Result(this.y8s_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.s8s_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function ShiftTradeRemoteSource(apiClient, sessionDataProvider) {
  this.h8t_1 = apiClient;
  this.i8t_1 = sessionDataProvider;
}
protoOf(ShiftTradeRemoteSource).x8o = function (status, $completion) {
  var tmp = new $getShiftTradesCOROUTINE$23(this, status, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_shiftPoolModule() {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  return shiftPoolModule;
}
var shiftPoolModule;
function shiftPoolModule$lambda($this$module) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = shiftPoolModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IShiftDropRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = shiftPoolModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IShiftTradeRemoteSource), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp7 = new TypeQualifier(getKClass(ShiftDrop));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = shiftPoolModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IListLocalSource), tmp7, definition, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp11 = new TypeQualifier(getKClass(ShiftTrade));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = shiftPoolModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IListLocalSource), tmp11, definition_0, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = shiftPoolModule$lambda$lambda_3;
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Singleton_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(ShiftDropRepository), null, definition_1, kind_3, secondaryTypes_3);
  var factory_3 = new SingleInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_3);
  }
  var tmp = new KoinDefinition($this$module, factory_3);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$21 = [getKClass(IShiftDropAccessor), getKClass(IShiftDropMutator)];
  binds(tmp, tmp$ret$21);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = shiftPoolModule$lambda$lambda_4;
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Singleton_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(ShiftTradeRepository), null, definition_2, kind_4, secondaryTypes_4);
  var factory_4 = new SingleInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_4);
  }
  var tmp_0 = new KoinDefinition($this$module, factory_4);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$27 = [getKClass(IShiftTradeAccessor), getKClass(IShiftTradeMutator)];
  binds(tmp_0, tmp$ret$27);
  return Unit_instance;
}
function shiftPoolModule$lambda$lambda($this$factory, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new ShiftDropRemoteSource(tmp, tmp$ret$1);
}
function shiftPoolModule$lambda$lambda_0($this$factory, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new ShiftTradeRemoteSource(tmp, tmp$ret$1);
}
function shiftPoolModule$lambda$lambda_1($this$single, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('shift_drops', tmp$ret$0);
}
function shiftPoolModule$lambda$lambda_2($this$single, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('shift_trades', tmp$ret$0);
}
function shiftPoolModule$lambda$lambda_3($this$single, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IShiftDropRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(ShiftDrop));
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(IShiftInvalidator), null, null);
  return new ShiftDropRepository(tmp, tmp_0, tmp$ret$3);
}
function shiftPoolModule$lambda$lambda_4($this$single, it) {
  _init_properties_ShiftPoolModule_kt__ohp8k8();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IShiftTradeRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(ShiftTrade));
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$4 = $this$single.q1d(getKClass(IShiftInvalidator), null, null);
  return new ShiftTradeRepository(tmp, tmp_0, tmp_1, tmp$ret$4);
}
var properties_initialized_ShiftPoolModule_kt_5ly16u;
function _init_properties_ShiftPoolModule_kt__ohp8k8() {
  if (!properties_initialized_ShiftPoolModule_kt_5ly16u) {
    properties_initialized_ShiftPoolModule_kt_5ly16u = true;
    shiftPoolModule = module_0(VOID, shiftPoolModule$lambda);
  }
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
protoOf($serializer_2).qz = typeParametersSerializers;
protoOf($serializer_3).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_2 = new Companion_0();
//endregion
//region block: exports
export {
  get_shiftPoolModule as get_shiftPoolModule2g85xkjmwpqak,
};
//endregion

